<template>
    <div class="home-page">
        <VueSlickCarousel v-bind="settings" >

            <div id="slide1" class="hero-slide-container">
                <div class="hero-text">
                        <h1>
                            Protective Gear that works as hard as you do
                        </h1>
                        <p>
                            We provide the solutions needed to make sure you
                            deliver on any job site with next level protection.
                        </p>
                </div>
            </div>
            <div id="slide2" class="hero-slide-container">
                <div class="hero-text">
                        <h1>
                            New Identity, Same Mission
                        </h1>
                        <p>
                            With the merger of West Chester Protective Gear and Protective Industrial Products in 2018, we have been working to mix the best product offerings with the outstanding service that West Chester Protective Gear has continually offered. Now we are reintroducing ourselves to you, a bigger, better version, with more to offer.
                        </p>
                        <div class="button-container">
                            <a href="/company" class="btn-round-white">READ OUR STORY</a>
                        </div>
                        
                </div>
                <div class="info-container">
                    <img src="/images/header/PIP-WestChester-Logo.svg" alt="logo" />
                </div>
            </div>
            <div id="slide3" class="hero-slide-container">
                <div class="hero-text">
                        <h1>
                            Commitment To Sustainability
                        </h1>
                        <p>
                            Sustainability covers everything from the materials we use when making products to how much paper we use in our offices. That is why we say “there is no one-word solution to the environmental issues we face.” PIP® is dedicated to continually identifying opportunities to use recycled materials and reduce waste as well as educating users on extending the use of PPE through better materials, care and laundering.
                        </p>
                        <div class="button-container">
                            <a href="https://www.pipglobal.com/sustainability" class="btn-round-white" target="_blank">READ MORE</a>
                        </div>
                </div>
            </div>

        </VueSlickCarousel>

        <div class="home-page-brands" data-aos="fade-up">
            <div>
                <h2>FROM HEAD TO TOE</h2>
                <p>
                    Our brands provide top-quality personal protective equipment that guarentees the highest level of safety and comfort.
                </p>
                <div class="button-container">
                    <router-link :to="{ path: '/brands' }" class="btn-round-black"
                        >OUR BRANDS</router-link
                    >
                </div>
            </div>
            <div>
                <img src="/images/home/Boss-logo.svg" alt="Boss logo">
                <img src="/images/home/PIP-logo.svg" alt="PIP logo">
                <img src="/images/home/Mud-logo.svg" alt="Mud logo">
                <img src="/images/home/SafetyWorks-logo.svg" alt="SafetyWorks logo">
                <img src="/images/home/Hearos-logo.svg" alt="Hearos logo">
                <img src="/images/home/WestCounty-logo.svg" alt="WestCounty logo">
            </div>
        </div>

        <div class="home-page-company" data-aos="fade-up">
            <div>
                <h2>LIFE AT <img src="/images/PIP-Logo-Web-White.svg" alt="pip logo"></h2>
                <p>
                    Joining our company is an exhilerating opportunity that promises growth, innovation, and a vibrant work environment. We foster a culture that values creativity,
                    collaboration, and continuous learning, empowering our employees to unleash their full potential. As a part of our team, you'll be at the forefront of groundbreaking
                    projects, working alongside talented individuals who are passionate about making a difference.
                </p>
                <div class="button-container">
                    <router-link :to="{ path: '/about-us/career-opportunities' }" class="btn-round-white"
                        >JOIN US</router-link
                    >
                </div>
                <!-- <router-link class="btn btn-primary" :to="{ name: 'about' }">Join Us</router-link> -->
            </div>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
    data() {
        return {
            industries: [
                {
                    name: "Automotive and Metal Fabrication",
                    id: "industry-automotive"
                },
                {
                    name: "Construction",
                    id: "industry-construction"
                },
                {
                    name: "Controlled Environment",
                    id: "industry-ce"
                },
                {
                    name: "Electrical Safety",
                    id: "industry-electrical"
                },
                {
                    name: "Facility Care and Waste Management",
                    id: "industry-facility-care"
                },
                {
                    name: "Food Processing",
                    id: "industry-food-processing"
                },
                {
                    name: "Industrial",
                    id: "industry-industrial"
                },
                {
                    name: "Welding",
                    id: "industry-welding"
                },
                {
                    name: "Oil and Gas",
                    id: "industry-oil-gas"
                }
            ],
            brandCategories: [
                {
                    name: "Contractor Professional",
                    id: "category-contractor"
                },
                {
                    name: "Lawn and Garden",
                    id: "category-lawn-garden"
                },
                {
                    name: "Automotive Aftermarket",
                    id: "category-automotive"
                },
                {
                    name: "Farm and Ranch",
                    id: "category-farm-ranch"
                }
            ],
            settings: {
                dots: true,
                dotsClass: "slick-dots custom-dot-class",
                edgeFriction: 0.35,
                infinite: true,
                speed: 500,
                autoplay: false,
                controls: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        };
    },
    methods: {
        getLogo() {
            return "/images/pip-logo-white.svg";
        }
    },
    components: { VueSlickCarousel }
};
</script>
